export class AbstractPipeHost {
}
//# sourceMappingURL=pipe-host.js.map